// extracted by mini-css-extract-plugin
module.exports = {"Clean":"Clean_Clean__2RQPz"};